import type { ErrorType } from '@/../../common/src/api/interface/vertify';
import { LinkType, Platform } from '@/../../common/src/utils/nativeApi/interface';
import type { H5ApplicationFormSession } from './h5ApplicationFormSession';

interface VhkUnauthorizedRuntime {
  getPlatform: () => Platform;
  getLinkType: () => LinkType | undefined;
  getCurrentUrl: () => string;
  getOriginalLoginUrl: () => string | null;
}

interface VhkUnauthorizedNavigation {
  showExpiredDialog: (onConfirm: () => Promise<void>) => void;
  replaceLocation: (url: string) => void;
}

interface VhkUnauthorizedHandlerDependencies {
  session: H5ApplicationFormSession;
  runtime: VhkUnauthorizedRuntime;
  navigation: VhkUnauthorizedNavigation;
}

export const createVhkUnauthorizedHandler = ({
  session,
  runtime,
  navigation,
}: VhkUnauthorizedHandlerDependencies) => {
  const { getPlatform, getLinkType, getCurrentUrl, getOriginalLoginUrl } = runtime;
  const { showExpiredDialog, replaceLocation } = navigation;
  let dialogShown = false;

  return (error: Pick<ErrorType, 'code'>): boolean => {
    const currentUrl = getCurrentUrl();
    const linkType = getLinkType();
    const isWhatsappProof = currentUrl.includes('whatsappProof');
    const shouldReturnToLogin =
      session.isFullForm() ||
      linkType === LinkType.ALL ||
      linkType === LinkType.WHATSAPP ||
      isWhatsappProof;
    if (
      Number(error.code) !== 100 ||
      getPlatform() !== Platform.MobileWebClient ||
      !shouldReturnToLogin
    ) {
      return false;
    }

    const storedLoginUrl = getOriginalLoginUrl();
    if (storedLoginUrl && currentUrl === storedLoginUrl) {
      session.clearAndFlush().catch(() => undefined);
      return false;
    }

    const originalLoginUrl = isWhatsappProof
      ? currentUrl.replace('vhk/clCredit/whatsappProof', 'pub/uploadlogin')
      : storedLoginUrl;

    if (dialogShown) return true;
    dialogShown = true;
    showExpiredDialog(async () => {
      if (!originalLoginUrl) return;

      await session.clearAndFlush();
      replaceLocation(originalLoginUrl);
    });
    return true;
  };
};
